<template>
  <div>
    <div class="d-sm-flex justify-space-between">
      <div class="slider-control d-flex align-center mx-2">
        <label>{{ $t("sankey.moodThreshold") }}</label>
        <HelpIcon>{{ moodThresholdHelpText }}</HelpIcon>
        <div class="slider-container">
          <v-slider
            v-model="moodThreshold"
            :thumb-size="24"
            :min="1"
            :max="thresholdMax"
            thumb-label="always"
            class="pt-8"
            hide-details
            :disabled="isMoodThresholdDisabled"
          ></v-slider>
        </div>
      </div>
      <div class="slider-control d-flex align-center mx-2">
        <label>{{ $t("sankey.motifThreshold") }}</label>
        <HelpIcon>{{ motifThresholdHelpText }}</HelpIcon>
        <div class="slider-container">
          <v-slider
            v-model="motifThreshold"
            :thumb-size="24"
            :min="1"
            :max="thresholdMax"
            thumb-label="always"
            class="pt-8"
            hide-details
            :disabled="isMotifThresholdDisabled"
          ></v-slider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelpIcon from "@/components/HelpIcon.vue";
export default {
  components: {
    HelpIcon
  },
  computed: {
    thresholdMax() {
      return this.$store.getters.thresholdMax;
    },
    motifThreshold: {
      get() {
        return this.$store.state.motifThreshold;
      },
      set(value) {
        this.$store.dispatch("updateMotifThreshold", +value);
      }
    },
    moodThreshold: {
      get() {
        return this.$store.state.moodThreshold;
      },
      set(value) {
        this.$store.dispatch("updateMoodThreshold", +value);
      }
    },
    isMotifThresholdDisabled() {
      return this.$store.getters.isMotifThresholdDisabled;
    },
    isMoodThresholdDisabled() {
      return this.$store.getters.isMoodThresholdDisabled;
    },
    moodThresholdHelpText() {
      return `${this.$t("sankey.moodThresholdHelpText", {
        threshold: this.moodThreshold
      })} ${this.$tc("pluralization.poem", this.moodThreshold)}`;
    },
    motifThresholdHelpText() {
      return `${this.$t("sankey.motifThresholdHelpText", {
        threshold: this.motifThreshold
      })} ${this.$tc("pluralization.poem", this.motifThreshold)}`;
    }
  }
};
</script>

<style scoped>
.slider-control {
  flex: 1 1 0;
}

.slider-control label {
  white-space: pre;
}

.slider-container {
  width: 120px;
}
</style>
